<template>
    <div>
        <CCol sm="12">
    
    
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
               
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <h3 class="font-color-171717 m-2"><strong class="custom-24px-700">Salary</strong> is Here!</h3>
                    <p class="font-color-98A2B3 ml-2 custom-16px-400">MyHR Solutions now is a partner with Orpheus Capital Sdn Bhd!</p>
                </CCard>
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                    <div class="mt-5 mb-5 text-center">
    <img src="../assets/img/moneynote.png" style="max-width:200px" />
    <h3 class="font-color-171717 custom-20px-600 mt-2">It's Faster Than You Think!</h3>
    <p class="custom-16px-400 font-color-98A2B3">Your application will process within 24 hours.</p>
    <div class="custom-info-blue" style="display: flex; justify-content: center; color:#0B63F6; width: 70%;margin:0 auto">
        Your application will be processed, and the loan will be reimbursed within 24 hours after approval.
        Terms and conditions apply.
    </div>
    <div style="display: flex; justify-content: center; width: 70%;margin:0 auto">
    <p class="font-color-98A2B3 ml-2 custom-16px-400 mt-2">GajiNow is an advanced salary service offered by collaboration of MyHR Solutions and Orpheus Capital Sdn Bhd. You can receive a loan of approximately half of your monthly salary (with a maximum limit of RM 2,000) before the regular payday. Repayment will be automatically deducted from your salary on the usual payday.
</p>
</div>
</div>
                   

                </CCard>
            </CCol>
    
        </CCol>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            leaveOptions: [{
                    id: 1,
                    name: 'Annual Leave'
                },
                {
                    id: 2,
                    name: 'Emergency Leave'
                },
                {
                    id: 3,
                    name: 'Maternity Leave'
                },
                {
                    id: 3,
                    name: 'Paternity Leave'
                },
            ],
            "events": [{
                    "id": 1,
                    "start": "2024-08-10T10:00:00",
                    "end": "2024-08-10T11:00:00",
                    "title": "Event Title",
                    "description": "Event Description"
                },
                // More events
            ],
            startDate: new Date(),
            defaultView: 'month', // Default view to month
            timeoffTableData: []

        }





    },
    async mounted() {
        this.$nextTick(() => {
   this.setCalendarView();
});
    //     try {
    //         const isAuth = await this.UserAuth();
    //         if (isAuth) {

    //         } else {
    //             this.GoToPage();
    //             this.$nextTick(() => {
    //   this.setCalendarView();
    // });
    //         }
    //     } catch (error) {
    //         this.GoToPage();
    //         console.error("Error during authentication:", error);
    //         // Handle the error here
    //     }

    },

    computed: {

    },
    created() {
    this.setDefaultMonth();
  },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
       
        onDayClick(date) {
      console.log('Date clicked:', date);
      // Handle day click event
    },
    setCalendarView() {
      const vueCal = this.$refs.vueCal;
      if (vueCal) {
        vueCal.setView(this.defaultView); // Set the calendar view to month
      }
    }


    }

};
</script>